import React, { useState } from 'react'
import { useStyles } from './DownloadMeteringHistory.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-regular-svg-icons'
import { LabraToolTipV2 } from '@labrav/react-components'
import { DownloadMeteringHistoryModal } from './DownloadMeteringHistoryModal/DownloadMeteringHistoryModal'

export const DownloadMeteringHistory = () => {
  const { classes } = useStyles()

  //modal configs
  const [openDownloadModal, setDownloadModal] = useState<boolean>(false)
  const openModal = () => {
    setDownloadModal(true)
  }
  const closeModal = () => {
    setDownloadModal(false)
  }

  return (
    <>
      <div
        className={classes.downloadButton}
        data-testid="download-button"
        onClick={openModal}
      >
        <LabraToolTipV2
          tooltipPlacement="top"
          description="Download metering history"
        >
          <FontAwesomeIcon
            icon={faDownload}
            width={18}
            height={18}
            color="#212121"
          />
        </LabraToolTipV2>
      </div>
      <DownloadMeteringHistoryModal
        open={openDownloadModal}
        onClose={closeModal}
      />
    </>
  )
}
